module.exports = __webpack_public_path__ + "img/m-plan.59f37abc.png";